import { dayMs, minuteMs } from "verdi-common/timeConstants";

const LEAD_MS = dayMs;
const END_STEP_MS = 5 * minuteMs;

export function padEventWindow(startMs: number, endMs: number): { startMs: number; endMs: number } {
    return {
        startMs: Math.floor(startMs / dayMs) * dayMs - LEAD_MS,
        endMs: Math.ceil((endMs + LEAD_MS) / END_STEP_MS) * END_STEP_MS,
    };
}
